import { COLUMNS } from "../FlowSheetEditor/utils"

export function copyData(data) {
  return JSON.parse(JSON.stringify(data))
}

export function getCoordinate(key: string) {
  const colChar = key.slice(0, 1)
  const rowNum = key.slice(1)
  const x = COLUMNS.findIndex((item) => item === colChar)
  const y = Number(rowNum) - 1
  return {x, y}
}